import { render, staticRenderFns } from "./ClasePage.vue?vue&type=template&id=1c1d29f8"
import script from "./ClasePage.js?vue&type=script&lang=js&external"
export * from "./ClasePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports